import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';

const fetchSubscriptionStatus = async (
  organizationId: number,
  product: string
) => {
  const response = await Axios.get(
    `${GET_URL(organizationId.toString(), product).organizationStatus}`,
    {
      headers: {
        accept: 'application/json'
      }
    }
  );

  return response.data;
};

const useGetSubscriptionStatus = (organizationId: number, product: string) => {
  return useQuery(
    ['subscriptionStatus', organizationId, product],
    () => fetchSubscriptionStatus(organizationId, product),
    {
      enabled: !!organizationId && !!product,
      refetchInterval: 10000 // Refetch every 10 seconds
    }
  );
};

export default useGetSubscriptionStatus;
